import { withErrorBoundary } from '@navi-app/utils';
import { Image } from '@unpic/react';
import { Card, StyledBody } from 'baseui/card';
import { LabelMedium, ParagraphXSmall } from 'baseui/typography';

export type TTutorialCard = {
  id: string;
  url: string | undefined;
  embedUrl: string | undefined;
  thumbnail: string;
  card: {
    title: string;
    description: string;
  };
  video: {
    title: string;
    description: string;
  };
  isActive: boolean;
  onClickCard: (id: string) => void;
};

const TutorialCard = ({
  id,
  thumbnail,
  card,
  isActive,
  onClickCard,
}: TTutorialCard) => {
  return (
    <Card
      overrides={{
        Root: {
          style: {
            backgroundColor: isActive ? '#EFF4FE' : 'white',
            cursor: 'pointer',
            border: isActive ? '2px solid #1E64DC' : '',
            marginBottom: '12px',
          },
        },
      }}
    >
      <StyledBody
        onClick={() => onClickCard(id)}
        className="flex place-items-center gap-3"
      >
        <Image
          src={thumbnail}
          alt={id}
          width={92}
          height={57}
          className="border border-[#E8E8E8] rounded-lg !h-[57px] object-cover"
        />
        <div className="flex-grow-0 flex-basis-2/5">
          <LabelMedium>{card?.title}</LabelMedium>
          <ParagraphXSmall color="#5E5E5E" className="mt-1">
            {card?.description}
          </ParagraphXSmall>
        </div>
      </StyledBody>
    </Card>
  );
};

export default withErrorBoundary(TutorialCard);
